import React from 'react'
import PropTypes from 'prop-types'

import RelatedCaseStudies from './RelatedCaseStudies'
import RelatedOriginals from './RelatedOriginals'

const RelatedProjects = ({ data, scrollbar }) => {
  if (!data) return null
  const type = data[0]?.project?.__typename.toLowerCase().includes('project') ? 'case' : 'original'
  return type === 'case' ? <RelatedCaseStudies data={data} /> : <RelatedOriginals data={data} scrollbar={scrollbar} />
}

RelatedProjects.propTypes = {
  data: PropTypes.array,
  scrollbar: PropTypes.object, // scrollbar isntance
}

export default RelatedProjects
